import { useRef } from "react";
import { useInView } from "framer-motion";
import { FadeUp, SectionLabel } from "./Reveal";
import { Row } from "./Works";
import { Phone } from "./Mockups";
import { Stats } from "./Stats";
import { PROJECTS } from "../data/content";
import { useLang } from "../lib/lang";

const REELS = [
  { v: "beauty", t: "Beauty reel" },
  { v: "adela", t: "Dra. Adela Camus" },
  { v: "savvy_kit", t: "Savvy Llama — starter kit" },
  { v: "savvy_anim", t: "Savvy Llama — motion" },
];

const SubHead = ({ n, children }) => (
  <FadeUp className="mb-12 flex items-end gap-4 border-b border-white/10 pb-6">
    <h3 className="font-display text-3xl font-medium tracking-tight sm:text-5xl"><span className="mr-4 font-mono text-sm text-[var(--acid)] align-middle">{n}</span>{children}</h3>
  </FadeUp>
);

const ReelsStrip = () => {
  const { tr } = useLang();
  const ref = useRef(null);
  const inView = useInView(ref, { amount: 0.3 });
  return (
    <div ref={ref} data-testid="reels-strip" className="grid grid-cols-2 gap-6 sm:gap-10 lg:grid-cols-4">
      {REELS.map((r, i) => (
        <FadeUp key={r.v} delay={i * 0.08} className={i % 2 ? "lg:translate-y-12" : ""}>
          <Phone src={`/video/${r.v}.jpg`} video={`/video/${r.v}.mp4`} play={inView} alt={tr(r.t)} />
          <p className="mt-4 text-center font-mono text-xs uppercase tracking-widest text-zinc-400">{tr(r.t)}</p>
        </FadeUp>
      ))}
    </div>
  );
};

export const SocialMedia = ({ onOpen }) => {
  const { tr } = useLang();
  const feed = PROJECTS.filter((p) => p.cat === "feed");
  const campaigns = PROJECTS.filter((p) => p.cat === "campaigns");
  return (
    <section id="social" data-testid="social-media-section" className="border-t border-white/10 bg-[#0d0d10] px-4 py-24 sm:px-6 lg:px-8 lg:py-36">
      <div className="mx-auto max-w-7xl">
        <div className="flex flex-col justify-between gap-8 lg:flex-row lg:items-end">
          <div>
            <SectionLabel index="02">{tr({ es: "Social media & community manager", en: "Social media & community manager" })}</SectionLabel>
            <FadeUp as="h2" className="mt-6 font-display text-5xl font-semibold uppercase leading-[0.9] tracking-tight sm:text-7xl lg:text-8xl">
              Social <span className="font-serif-i normal-case text-[var(--acid)]">{tr({ es: "que conecta.", en: "that connects." })}</span>
            </FadeUp>
          </div>
          <FadeUp className="max-w-sm text-zinc-400">
            {tr({ es: "Estrategia, contenido y comunidad: feeds, reels, TikTok, YouTube y campa\u00f1as que mueven n\u00fameros reales.", en: "Strategy, content and community: feeds, reels, TikTok, YouTube and campaigns that move real numbers." })}
          </FadeUp>
        </div>
        <Stats />
        <div className="mt-28 space-y-32 lg:space-y-40">
          <div>
            <SubHead n="A">{tr({ es: "Feeds de Instagram \u2014 antes y despu\u00e9s", en: "Instagram feeds \u2014 before & after" })}</SubHead>
            {feed.map((p, i) => <Row key={p.id} p={p} i={i} total={feed.length} onOpen={() => onOpen(p)} />)}
          </div>
          <div>
            <SubHead n="B">{tr({ es: "Reels, TikTok & YouTube", en: "Reels, TikTok & YouTube" })}</SubHead>
            <ReelsStrip />
          </div>
          <div>
            <SubHead n="C">{tr({ es: "Campa\u00f1as destacadas", en: "Highlight campaigns" })}</SubHead>
            <div className="space-y-24 lg:space-y-32">
              {campaigns.map((p, i) => <Row key={p.id} p={p} i={i} total={campaigns.length} onOpen={() => onOpen(p)} />)}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
